module.exports = __webpack_public_path__ + "img/squinting-face-with-tongue.ca6d1300.png";